import HelperLine from "../components/v2/HelperLine";
import PageTransition from "../components/v2/PageTransition";
import RecapCard from "../components/v2/RecapCard";
import StickySendButton from "../components/v2/StickySendButton";
import Wordmark from "../components/v2/Wordmark";
import { RELATIONSHIP_OPTIONS } from "./Surface7";
import { TECH_COMFORT_OPTIONS } from "./Surface8";
import { SPEECH_STYLE_OPTIONS } from "./Surface12";
import "../components/v2/v2-question-surface.css";

const OPTION_LABELS = Object.fromEntries(
  [...RELATIONSHIP_OPTIONS, ...TECH_COMFORT_OPTIONS, ...SPEECH_STYLE_OPTIONS].map((option) => [option.key, option.title])
);

const RECAP_ITEMS = [
  { id: "introducerName", label: "Your name" },
  { id: "recipientName", label: "Their name" },
  { id: "relationship", label: "How you know them", type: "single" },
  { id: "tech", label: "Tech comfort", type: "single" },
  { id: "work", label: "Their work" },
  { id: "outside", label: "What they enjoy" },
  { id: "personality", label: "Their personality" },
  { id: "speech_style", label: "How they talk", type: "tags" },
  { id: "season", label: "The season they're in", skippable: true },
  { id: "downplay", label: "What they downplay" },
  { id: "lightup", label: "When they light up" },
  { id: "avoid", label: "To know or avoid", skippable: true },
];

function displayValue(item, answers) {
  const raw = answers[item.id];
  if (item.type === "tags") {
    return Array.isArray(raw) ? raw.map((key) => OPTION_LABELS[key] || key) : [];
  }
  if (item.type === "single") return OPTION_LABELS[raw] || raw || "";
  return raw || "";
}

export default function Surface17({
  answers,
  introducerName,
  recipientName,
  direction = "forward",
  onEdit,
  onSend,
}) {
  const header = introducerName
    ? `Thanks, ${introducerName}. Here's what you shared about ${recipientName}.`
    : `Here's what you shared about ${recipientName}.`;

  return (
    <section className="tgc-v2-surface tgc-v2-surface--review" aria-labelledby="review-heading">
      <PageTransition direction={direction}>
        <div className="tgc-v2-review-shell">
          <header className="tgc-v2-review-header">
            <Wordmark variant="stacked" />
            <h1 className="tgc-v2-review-heading" id="review-heading">{header}</h1>
            <HelperLine id="review-helper">Edit anything before this becomes their conversation.</HelperLine>
          </header>

          <div className="tgc-v2-review-scroll" aria-describedby="review-helper">
            {RECAP_ITEMS.map((item) => {
              const value = displayValue(item, answers);
              const isSkipped = item.skippable && !String(value || "").trim();
              return (
                <RecapCard
                  key={item.id}
                  label={item.label}
                  answer={value}
                  tags={item.type === "tags" ? value : null}
                  skipped={isSkipped}
                  editLabel={isSkipped ? "Add" : "Edit"}
                  editAriaLabel={`${isSkipped ? "Add" : "Edit"} ${item.label.toLowerCase()}`}
                  onEdit={() => onEdit(item.id)}
                />
              );
            })}
          </div>

          <StickySendButton onSend={onSend} />
        </div>
      </PageTransition>
    </section>
  );
}
